module.exports = __webpack_public_path__ + "img/dave-family.1a1d592c.png";